import { type PimProductV11 } from '@redteclab/api/clients/bully'

export const productAccessorGetLowestPrice = (
  variants: PimProductV11[],
): number => {
  let lowestPrice = 0

  for (const variant of variants) {
    if (variant.offers) {
      for (const offer of variant.offers) {
        const price = offer.offerPrice?.price ?? 0
        if (lowestPrice === 0 || lowestPrice > price) {
          lowestPrice = price
        }
      }
    }
  }

  return lowestPrice
}
